import React from 'react';
import './table.css';

const LeftTable = ({tabData}) => {
  const data = tabData?.map(item => ({
    month: item.label,
    billingValue: `₹ ${item.totalBillingValue.cost.toFixed(2)} (${item.totalBillingValue.totalOrders})`,
    invoiceValue: `₹ ${item.totalInvoiceBillingValue.cost.toFixed(2)} (${item.totalInvoiceBillingValue.totalOrders})`,
  }));

  return (
    <div className="p-4 rounded-lg flex-2 summary-table relative" style={{ background: '#F2F2F2', border: '1px solid #B0E3D9'}}>
      <span className="text-2xl mr-2 absolute top-4 left-1">
        <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_1135_1365)">
            <path d="M8 10.8C8 8.14903 10.149 6 12.8 6H32C34.651 6 36.8 8.14903 36.8 10.8V30C36.8 32.651 34.651 34.8 32 34.8H12.8C10.149 34.8 8 32.651 8 30V10.8Z" fill="#00A584"/>
            <path d="M12.7998 6.5H32C34.3748 6.5 36.2997 8.42507 36.2998 10.7998V30C36.2998 32.3748 34.3748 34.2998 32 34.2998H12.7998C10.4251 34.2997 8.5 32.3748 8.5 30V10.7998C8.50011 8.42514 10.4251 6.50011 12.7998 6.5Z" stroke="#00765E"/>
            <path d="M25.75 17.7992L18.25 13.4742M14.725 15.7659L22 19.9742L29.275 15.7659M22 28.3659V19.9659M29.5 23.2992V16.6326C29.4997 16.3403 29.4225 16.0532 29.2763 15.8002C29.13 15.5472 28.9198 15.337 28.6667 15.1909L22.8333 11.8576C22.58 11.7113 22.2926 11.6343 22 11.6343C21.7074 11.6343 21.42 11.7113 21.1667 11.8576L15.3333 15.1909C15.0802 15.337 14.87 15.5472 14.7237 15.8002C14.5775 16.0532 14.5003 16.3403 14.5 16.6326V23.2992C14.5003 23.5915 14.5775 23.8786 14.7237 24.1316C14.87 24.3846 15.0802 24.5948 15.3333 24.7409L21.1667 28.0742C21.42 28.2205 21.7074 28.2975 22 28.2975C22.2926 28.2975 22.58 28.2205 22.8333 28.0742L28.6667 24.7409C28.9198 24.5948 29.13 24.3846 29.2763 24.1316C29.4225 23.8786 29.4997 23.5915 29.5 23.2992Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <filter id="filter0_d_1135_1365" x="0" y="0" width="48.8" height="48.7998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="2" dy="4"/>
            <feGaussianBlur stdDeviation="5"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1135_1365"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1135_1365" result="shape"/>
            </filter>
            </defs>
            </svg>
      </span>
      <h3 className='text-lg font-semibold ml-[30px] mt-[1px]' style={{fontSize: '16px'}}>Dispatched Data</h3>
      <table className="w-full text-center border-collapse mt-[28px]">
        <thead>
          <tr className="border-none">
            <th className="p-2 border-none">Month</th>
            <th className="p-2 border-none">Total Billing Value </th>
            <th className="p-2 border-none">Invoice Value</th>
          </tr>
        </thead>
        <tbody>
          {/* <tr className='border-none'><td className='border-none' colspan="1" style={{height: '12px'}}></td></tr>
          <tr className='border-none'><td className='border-none' colspan="1" style={{height: '12px'}}></td></tr>
          <tr className='border-none'><td className='border-none' colspan="1" style={{height: '12px'}}></td></tr> */}
          {/* <tr className='border-none'><td className='border-none' colspan="1" style={{height: '14px', background: '#F8F8F8'}}></td></tr> */}
          {data.map((row, index) => (
            <tr key={index} className={index % 2 === 0 ? 'border-none' : 'border-none'} style={{ height: '50px' }}>
              <td className="p-2 border-none whitespace-nowrap" style={{ fontSize: '14px' }}>{row.month}</td>
              <td className="p-2 border-none" style={{ fontSize: '14px' }}>{row.billingValue}</td>
              <td className="p-2 border-none" style={{ fontSize: '14px' }}>{row.invoiceValue}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeftTable;